export const pauseIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="none"><path d="M0 0h24v24H0z"/><path fill="currentColor" d="M4 4h6.4v16H4zm9.6 0H20v16h-6.4z"/></g></svg>`,
    name: 'pause' as const
};